module.exports = __webpack_public_path__ + "img/Wu Tau.e87b0a80.svg";